const data = [
  {
    question: "Explain event delegation.",
    url: "",
    status: 0,
  },
  {
    question: "Explain how this works in JavaScript",
    url: "",
    status: 0,
  },
  {
    question: "Explain how prototypal inheritance works.",
    url: "",
    status: 0,
  },
  {
    question: "What is a closure, and how/why would you use one?",
    url: "",
    status: 0,
  },
  {
    question:
      " What language constructions do you use for iterating over object properties and array items?",
    url: "",
    status: 0,
  },
];

const buttonList = [
  {
    name: "btn",
    status: 1,
    id: "btn_1",
    value: "Не починала",
  },
  {
    name: "btn",
    status: 2,
    id: "btn_2",
    value: "Розібрався",
  },
  {
    name: "btn",
    status: 3,
    id: "btn_3",
    value: "Незрозуміло",
  },
];

export { data, buttonList };
